import React, { useEffect, useState } from 'react'
import MenuIcon from '../../../../components/icons/MenuIcon'
import AddCircle from '../../../../components/icons/AddCircle'
import SyncIco from '../../../../components/icons/SyncIco'
import CropFreeIco from '../../../../components/icons/CropFreeIco'
import CameraIco from '../../../../components/icons/CameraIco'
import DashboardMenu from './DashboardMenu'
import DashboardDataRange from './DashboardDataRange'
import { useDashboards } from '../../../../providers/DashboardContext'
import InputForm from '../../../../components/InputForm'
import FloatTabSelector from '../../../../components/Dashboard/FloatTabSelector'
import NoDashboards from './NoDashboards'
import { useAuth } from '../../../../providers/AuthContext'
import { useWidgets } from '../../../../providers/WidgetContext'


function HeadBar({toggleNewWidgetModal, onToggleFullscreen, onCaptureScreenshot}) {
  const {dashboard, selectedDatarange, setDataRangeCurrentDashboard, setFactorCurrentDashboard, handleSelectionTab,setSelectedTab, selectedTab} = useDashboards();
  const {refreshWidgetList} = useWidgets()
  const [currentFactor, setCurrentFactor] = useState("")
  const {hasPermission} = useAuth()
  // El factor se puede refrescar en vivo (cambia de valor, no de tab activo).
  useEffect( () => {
    if (dashboard){
      setCurrentFactor(dashboard.factor)
    }
  }, [dashboard])

  // OJO: esto solo debe correr cuando se carga un dashboard DISTINTO (o al
  // entrar por primera vez), no en cada actualización de metadata (nombre,
  // filtro de fecha, factor) que llega por socket - si dependiera de
  // `dashboard` completo, cada cambio remoto reseteaba el tab seleccionado
  // al primero y eso a su vez disparaba un refetch completo de los widgets
  // (parpadeo de todo el dashboard) en vez de una actualización suave.
  useEffect( () => {
    if (dashboard){
      setSelectedTab(dashboard?.tabList?.[0])
    }
  }, [dashboard?._id])
  return (
    <>
      { dashboard && (
        <div className='bg-white shadow-md w-full px-4 min-h-[6%] flex items-center justify-between'>
          <div className='flex gap-1 basis-1/3'>
            <DashboardMenu />
            <span className=' my-auto'>{dashboard.name}</span>
            {hasPermission("Dashboard", "Factor", "UPDATE") && (
              <div className='w-32 h-8 pl-12 flex '>
                <input className='mt-2 border-b-2 w-full  text-center ' placeholder='Factor' value={currentFactor}  onChange={event => setFactorCurrentDashboard(event.target.value)}/>
                {/* <InputForm text={"Factor"} AppendClassName='-mb-4' value={currentFactor} onChange={event => setFactorCurrentDashboard(event.target.value)}/> */}
              </div>
            )}
            
          </div>
          
          <DashboardDataRange dateRange={selectedDatarange} onChange={setDataRangeCurrentDashboard}/>
        
          <div className='flex gap-3 items-center basis-1/3 justify-end'>
            <button onClick={onCaptureScreenshot}>
               <CameraIco height='25px' width="25px" fill='bluesens' />
            </button>
            <button onClick={onToggleFullscreen}>
              <CropFreeIco height='25px' width="25px" fill='bluesens' />
            </button>

            <button onClick={refreshWidgetList}>
              <SyncIco height='25px' width="25px" fill='bluesens'/>
            </button>
            

            {
              hasPermission("Dashboard", "Widget", "CREATE") &&(
              <button onClick={toggleNewWidgetModal}>
                <AddCircle height='35px' width="35px" fill='bluesens'/>
              </button>
            )}
            
            
          </div>
          
          { dashboard.isTabulated && (
            <FloatTabSelector selectedTab = {selectedTab} title={"Tabs"} options={dashboard.tabList || []} onChange={tab => handleSelectionTab(tab)} />
          )}
        </div>
      )}
      { !dashboard && (
        <NoDashboards />
      )}
    </>
    
  )
}

export default HeadBar